export const MATERIAL_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "material.scrap_metal",
        name: "SCRAP METAL",
        description: "Mixed steel fragments. Corroded but usable.",
        category: "MATERIAL",
        tags: ["METAL", "SALVAGE"],
        stackLimit: 50,
        unitMassGrams: 180,
        volumeMl: 180,
        longestDimensionMm: 140,
        iconKey: "metal",
        worldAssetId: "scrap_bundle",
        scarcity: "COMMON",
        sortOrder: 40,
    },
    {
        id: "material.aluminum_scrap",
        name: "ALUMINUM SCRAP",
        description: "Light alloy offcuts with sharp folded edges.",
        category: "MATERIAL",
        tags: ["METAL", "SALVAGE"],
        stackLimit: 50,
        unitMassGrams: 90,
        volumeMl: 170,
        longestDimensionMm: 145,
        iconKey: "metal",
        worldAssetId: "scrap_bundle",
        scarcity: "COMMON",
        sortOrder: 41,
    },
    {
        id: "material.cloth_rag",
        name: "CLOTH RAG",
        description: "Dry woven cloth, torn into manageable strips.",
        category: "MATERIAL",
        tags: ["FABRIC", "SALVAGE"],
        stackLimit: 20,
        unitMassGrams: 35,
        volumeMl: 85,
        longestDimensionMm: 110,
        iconKey: "fabric",
        worldAssetId: "cloth_bundle",
        scarcity: "COMMON",
        sortOrder: 42,
    },
    {
        id: "material.duct_tape",
        name: "DUCT TAPE",
        description: "A partial roll of reinforced repair tape.",
        category: "MATERIAL",
        tags: ["FABRIC", "PLASTIC"],
        stackLimit: 8,
        unitMassGrams: 160,
        volumeMl: 220,
        longestDimensionMm: 105,
        iconKey: "tape",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 43,
    },
    {
        id: "material.rubber_piece",
        name: "RUBBER PIECE",
        description: "A flexible piece cut from industrial rubber.",
        category: "MATERIAL",
        tags: ["SALVAGE"],
        stackLimit: 30,
        unitMassGrams: 70,
        volumeMl: 90,
        longestDimensionMm: 125,
        iconKey: "rubber",
        worldAssetId: "pickup_bundle",
        scarcity: "COMMON",
        sortOrder: 44,
    },
]);
